import React from "react";
import { Box, Container, Stack, Typography, Button } from "@mui/material";
import Iconify from "./Iconify";
import { INK, ACCENT_DARK, ctaGlowSx } from "../theme/brand";
import { REGISTER_URL } from "../config";

export default function PromoBar() {
  return (
    <Box
      sx={{
        bgcolor: "rgba(91,79,212,0.06)",
        borderBottom: "1px solid rgba(91,79,212,0.12)",
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems="center"
          justifyContent="center"
          spacing={{ xs: 1, sm: 2 }}
          sx={{ py: { xs: 1.1, sm: 0.9 } }}
        >
          <Stack
            direction="row"
            spacing={1.25}
            alignItems="center"
            flexWrap="wrap"
            justifyContent="center"
            sx={{ textAlign: "center" }}
          >
            <Stack
              direction="row"
              spacing={0.6}
              alignItems="center"
              sx={{
                bgcolor: "#fff",
                border: "1px solid rgba(91,79,212,0.22)",
                borderRadius: 999,
                px: 1.1,
                py: 0.3,
                boxShadow: "0 1px 2px rgba(42,35,83,0.06)",
                flexShrink: 0,
              }}
            >
              <Iconify icon="mdi:gift-outline" width={13} sx={{ color: ACCENT_DARK }} />
              <Typography sx={{ fontSize: 12, fontWeight: 800, color: ACCENT_DARK, whiteSpace: "nowrap" }}>
                1 Monat kostenlos
              </Typography>
            </Stack>
            <Typography sx={{ fontSize: 13, fontWeight: 500, color: INK, opacity: 0.75 }}>
              keine Kosten während der Testphase.
            </Typography>
          </Stack>

          <Button
            href={REGISTER_URL}
            variant="contained"
            size="small"
            endIcon={<Iconify icon="mdi:arrow-right" width={14} />}
            sx={{ px: 2, py: 0.4, fontSize: 12.5, flexShrink: 0, ...ctaGlowSx }}
          >
            Jetzt starten
          </Button>
        </Stack>
      </Container>
    </Box>
  );
}
